import {
  type ReactNode,
  useEffect,
} from "react";

import { useGetCart } from "@/stf.data/hook.cart";

import { CartContext } from "./cart.context";
import { useCart } from "./hook.use-cart";

interface CartRootProps {
  children: ReactNode;
}
const CartRoot = (props: CartRootProps) => {
  const { children } = props;
  const [cartState, dispatchCartAction] = useCart();
  const { data, isSuccess } = useGetCart();

  useEffect(() => {
    if (isSuccess && data !== undefined) {
      dispatchCartAction({
        payload: {
          cartData: data,
          selectedCartItemId: [],
        },
        type: "initData",
      });
    }
  }, [data, isSuccess]);

  return (
    <CartContext.Provider value={{
      cartState,
      dispatchCartAction,
    }}
    >
      {children}
    </CartContext.Provider>
  );
};

export { CartRoot };
